/* Despliegue animado de los acordeones del producto con GSAP.
   El <details> nativo abre/cierra de golpe; aca interceptamos el click:
   - abrir: se setea open y el contenido crece de 0 a auto con fade.
   - cerrar: el contenido colapsa y recien al final se saca el open.
   Con prefers-reduced-motion se deja el toggle nativo. */
(function () {
  function init() {
    if (!window.gsap) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Solo los acordeones de la ficha del producto (envios, garantia).
       El FAQ (collapsible-content) usa el toggle nativo. */
    document.querySelectorAll('.product__accordion details').forEach(function (details) {
      var summary = details.querySelector('summary');
      var content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      summary.addEventListener('click', function (e) {
        if (reduce) return;
        e.preventDefault();
        if (gsap.isTweening(content)) return;

        if (details.open) {
          gsap.set(content, { overflow: 'hidden' });
          gsap.to(content, {
            height: 0,
            opacity: 0,
            duration: 0.28,
            ease: 'power2.in',
            onComplete: function () {
              details.open = false;
              gsap.set(content, { clearProps: 'height,opacity,overflow' });
            }
          });
        } else {
          details.open = true;
          gsap.set(content, { overflow: 'hidden' });
          gsap.fromTo(
            content,
            { height: 0, opacity: 0 },
            {
              height: 'auto',
              opacity: 1,
              duration: 0.35,
              ease: 'power2.out',
              onComplete: function () {
                gsap.set(content, { clearProps: 'height,opacity,overflow' });
              }
            }
          );
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
